export default "__VITE_ASSET__7MBniGND__"